<template>
  <div class="relative-position">
    <div class="background" >
      <Menu />
    </div>
    <router-view/>
  </div>
</template>



<script>
import { ref } from '@vue/reactivity'
import Menu from './components/Menu.vue'
import { useRoute } from 'vue-router'
export default {
  components: { Menu },
  
  setup() {

    const route = useRoute()

    console.log(route.fullPath)

    const openMenu = ref(false)
    
    return { openMenu, route }
  },
}
</script>


<style lang="scss">



#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
